module.exports = __webpack_public_path__ + "img/success.9bacb893.png";